export const unlayerEmailMergeTags = {
  contact_shortcodes: {
    name: 'Contact Shortcodes',
    mergeTags: {
      contact_first_name: {
        name: 'Contact First Name',
        value: '[CONTACT_FIRST_NAME]',
        sample: '[CONTACT_FIRST_NAME]',
      },
      contact_last_name: {
        name: 'Contact Last Name',
        value: '[CONTACT_LAST_NAME]',
        sample: '[CONTACT_LAST_NAME]',
      },
      contact_nickname: {
        name: 'Contact Nickname',
        value: '[CONTACT_NICKNAME]',
        sample: '[CONTACT_NICKNAME]',
      },
      contact_email: {
        name: 'Contact Email Address',
        value: '[CONTACT_EMAIL]',
        sample: '[CONTACT_EMAIL]',
      },
      contact_email_urlenc: {
        name: 'Contact Email Address (Encoded)',
        value: '[CONTACT_EMAIL_URLENC]',
        sample: '[CONTACT_EMAIL_URLENC]',
      },
    },
  },
  content_shortcodes: {
    name: 'Content Shortcodes',
    mergeTags: {
      unsubscribe_url: {
        name: 'Unsubscribe URL',
        value: '[UNSUBSCRIBE_URL]',
        sample: '[UNSUBSCRIBE_URL]',
      },
      view_in_browser_link: {
        name: 'View in Browser Link',
        value: '[VIEW_IN_BROWSER_LINK]',
        sample: "[VIEW_IN_BROWSER_LINK]",
      },
      view_in_browser_url: {
        name: 'View in Browser URL',
        value: '[VIEW_IN_BROWSER_URL]',
        sample: '[VIEW_IN_BROWSER_URL]',
      },
      forward_to_friend_link: {
        name: 'Forward to a Friend Link',
        value: '[FORWARD_TO_A_FRIEND_LINK]',
        sample: "[FORWARD_TO_A_FRIEND_LINK]",
      },
      current_year: {
        name: 'Current Year',
        value: '[CURRENT_YEAR]',
        sample: '[CURRENT_YEAR]',
      },
    },
  },
};
